interface PageNotFoundProps {
  isRoot: boolean;
}

const NotFound: React.FC<PageNotFoundProps> = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
      </div>
    </div>
  );
};

export default NotFound;
